<script>
import {myPath} from "@/utils/constant";

export default {
  name: "LeaveSelectPage",
  data() {
    return {
      items: []
    }
  },
  mounted() {
    this.items = this.$store.state.pageSetting.find(item => item.url === myPath.leaveSelect).items
  },

  methods: {
    onItemClick(item) {
      this.$router.push({name: item.url})
    },
    onBackClick() {
      this.$router.back()
    }
  }

}
</script>

<template>
  <div class="select-page-box">
    <div class="back-btn" @click="onBackClick">
      <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
    </div>

    <div class="page-title">请选择签离方式</div>

    <div class="svc-list">
      <div v-for="card in items" :key="card.url" class="svc" style="width:500px;height:520px" @click="onItemClick(card)">
        <img class="ico" :src="card.image" alt="">
        <span class="name">{{ card.title }}</span>
      </div>
    </div>
  </div>
</template>
